import withStyles from '@material-ui/core/styles/withStyles';
import HotelIcon from '@serko/zui-icons/es/HotelIcon';
import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { HotelSegmentDetails } from '../../../../../../../../models/itinerary';
import { Logo } from './Logo';

interface OwnProps {
  /**
   * Hotel provider code (e.g. "LM")
   */
  code: HotelSegmentDetails['chainCode'];

  /**
   * Supplier name
   *
   * @example
   * "Virgin Airways"
   */
  name: HotelSegmentDetails['chainName'];
}

interface HotelLogoProps extends OwnProps {}

class HotelLogoBase extends PureComponent<HotelLogoProps> {
  private get src() {
    return `./hotel-chain-logos/${this.props.code}_1x.png`;
  }
  public render() {
    const { name, code, ...props } = this.props;
    return (
      <Logo src={this.src} alt={name} fallbackIcon={HotelIcon} {...props} />
    );
  }
}

const enhance = compose<HotelLogoProps, OwnProps>(
  withStyles({}, { name: 'ZuiImage' }), // Logos component is expecting the element.type.options.name to be 'ZuiImage'
);

export const HotelLogo = enhance(HotelLogoBase);

HotelLogo.displayName = 'HotelLogo';
